import { BrandApi } from "@core/apis/core/brand.api";
import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const OnboardingManagersNotificationsRoutes = [
    {
        "url": "/brand/:brand_id/managers-notifications",
        "name": "appLayout.harriSH.managers-notifications",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "managersNotifications",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding_managers_notifications", "harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/managers-notifications/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.settings.managers-notifications",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "showSettingsHeader": true,
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "managersNotifications",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding_managers_notifications", "harri-engage"]
        },
        "onEnter": ['$stateParams', '$state', 'hmapService', 'userPermissions', 'brandServices', async function ($stateParams, $state, hmapService, userPermissions, brandServices) {
                const activeBrandId = hmapService.getActiveBrandId($stateParams['hmapPath']);
                const [policyParser, isTeamEnabled,] = await Promise.all([
                    userPermissions.getBrandPolicy(activeBrandId),
                    brandServices.check(brandServices.SERVICES.TEAM, activeBrandId, true),
                ]);
                if (!isTeamEnabled ||
                    !policyParser.has(userPermissions.PERMISSIONS['MANAGE_NOTIFICATIONS'])) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
                const entryBrandSettings = await BrandApi.getEntryBrandSettings(activeBrandId);
                if (!entryBrandSettings.enable_core_hr_notifications) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/brand/:brand_id/notification-details/:notification_id",
        "name": "appLayout.harriSH.edit-notification",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "manageNotifications",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding_managers_notifications", "harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/notification-details/:notification_id/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.settings.edit-notification",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "manageNotifications",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding_managers_notifications", "harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/brand/:brand_id/create-notification",
        "name": "appLayout.harriSH.create-notification",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "manageNotifications",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding_managers_notifications-engage", "harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/create-notification/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.settings.create-notification",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "manageNotifications",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding_managers_notifications-engage", "harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/settings",
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["onboarding_managers_notifications-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-managers-notifications/onboarding-managers-notifications.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=onboarding-managers-notifications.routes.js.map